module.exports = __webpack_public_path__ + "img/thumb4.52681e5c.png";